// collection card images
(function () {
  var load = function (img) {
    if (img.dataset.src) {
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }
  };

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          load(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '100px' })
    : null;

  var watch = function (root) {
    (root || document).querySelectorAll('#product-grid img[data-src]').forEach(function (img) {
      if (!observer) {
        load(img);
        return;
      }
      observer.observe(img);
    });
  };

  var boot = function () {
    watch(document);
    var grid = document.getElementById('product-grid');
    if (!grid || grid.dataset.lazyWatch === 'true') return;
    grid.dataset.lazyWatch = 'true';
    new MutationObserver(function () {
      watch(grid);
    }).observe(grid, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

// collection parts slider
(function () {
  if (document.querySelector('.collection_h2_section__block_slider')) {
    var collectionH2SectionBlockSlider = new Swiper('.collection_h2_section__block_slider', {
      spaceBetween: 24,
      slidesPerView: 1,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: {
          slidesPerView: 1
        },
        1024: {
          slidesPerView: 2
        }
      }
    });

    var loadMedia = function (el) {
      if (el.dataset.href) {
        el.setAttribute('href', el.dataset.href);
        el.setAttributeNS('http://www.w3.org/1999/xlink', 'href', el.dataset.href);
        el.removeAttribute('data-href');
      }
      if (el.dataset.src) {
        el.src = el.dataset.src;
        el.removeAttribute('data-src');
      }
    };

    document.querySelectorAll('.collection_h2_section__block_slider').forEach(function (root) {
      var pending = function () {
        return root.querySelectorAll('image[data-href], img[data-src]');
      };
      if (!pending().length || !('IntersectionObserver' in window)) {
        pending().forEach(loadMedia);
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          loadMedia(entry.target);
          observer.unobserve(entry.target);
        });
      }, { root: root, rootMargin: '100px', threshold: 0.01 });
      var watch = function () {
        pending().forEach(function (el) {
          observer.observe(el);
        });
      };
      watch();
      if (root.swiper) {
        root.swiper.on('slideChange', watch);
        root.swiper.on('transitionEnd', watch);
      }
    });
  }
})();
// collection parts slider

// redirect from page 1
(function () {
  if (document.body.classList.contains('template_collection')) {
    if (window.location.search) {
      const params = new URLSearchParams(window.location.search);
      if (params.get('page') === '1') {
        const cleanUrl = window.location.origin + window.location.pathname;
        window.location.href = cleanUrl;
      }
    }
  }
})();
// redirect from page 1
